import React from 'react';
import { Link } from 'react-router-dom';

import formatDate from 'Shared/util/formatDate';

const LeftPart = ({ data }) => {
  const { reference, subject, createdAt, supplier, customer, invoices } = data;

  return (
    <div className="tab-order-detail__left-part">
      <div className="tab-order-detail__paper">
        <div className="header">
          <div className="header__cell">
            <span className="header__title">{reference}</span>
            <span className="header__label">{subject}</span>
          </div>
          <div className="header__cell">
            <div className="header__row header__row--end">
              {invoices &&
                invoices.length > 0 &&
                invoices.map((item) => (
                  <Link
                    className="header__invoice header__invoice--info"
                    key={item.id}
                    to={`/customer/invoice/detail/${item.id}`}
                    data-testid="order-ref-link"
                  >
                    {item.reference}
                  </Link>
                ))}
            </div>
          </div>
        </div>
        <div className="paper-container">
          <div className="paper-container__row">
            <div className="cell">
              <div className="paper-label">Issue date</div>
              <div className="paper-title">{formatDate(createdAt)}</div>
            </div>
            <div className="cell">
              <div className="paper-label">Work period</div>
              {/* TODO: Add work period */}
              {/* <div className="paper-title">{formatDate(createdAt)}</div> */}
            </div>
          </div>
        </div>
        {supplier && (
          <div className="paper-container">
            <div className="paper-container__row">
              <div className="cell">
                <div className="paper-label">Supplier</div>
                <div className="paper-title">{supplier.title}</div>
                <div className="paper-description">{supplier.address1}</div>
              </div>
            </div>
            <div div className="paper-container__row">
              <div className="cell">
                <div className="paper-label">Registration number</div>
                <div className="paper-title">{supplier.vatNumber}</div>
              </div>
            </div>
          </div>
        )}
        {customer && (
          <div className="paper-container">
            <div className="cell">
              <div className="paper-label">Customer</div>
              <div className="paper-title">{customer.title}</div>
              <div className="paper-description">{customer.address1}</div>
            </div>
          </div>
        )}
        <div className="paper-container">
          <div className="paper-container__row">
            <div className="paper-label">Represented by Andrey Zarubin, who acts according to the charter</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftPart;
